export const getContacts = (state) => state.contacts
export const getFunders = (state) => state.funders
export const getInvoices = (state) => state.invoices
export const getEstimates = (state) => state.estimates
export const getPurchaseOrders = (state) => state.purchaseOrders
export const getExpenses = (state) => state.expenses
export const getRecentInvoices = (state) => state.recentInvoices
export const getNewContacts = (state) => state.newContacts
export const getTotalDueAmount = (state) => state.totalDueAmount

export const getDueInvoices = (state) => state.dueInvoices
export const getOfferInvoices = (state) => state.offerInvoices
export const getRecentEstimates = (state) => state.recentEstimates

export const getLoadedData = (state) => state.isDataLoaded

export const getWeeklyInvoicesCounter = (state) => state.weeklyInvoices.counter
export const getWeeklyInvoicesDays = (state) => state.weeklyInvoices.days

export const getChartMonths = (state) => state.chartData.months
export const getChartInvoices = (state) => state.chartData.invoiceTotals
export const getChartOutstandingInvoices = (state) => state.chartData.outstandingInvoiceTotals
export const getChartExpenses = (state) => state.chartData.expenseTotals
export const getNetProfits = (state) => state.chartData.netProfits
export const getReceiptTotals = (state) => state.chartData.receiptTotals

export const getTotalOutstandingInvoices = (state) => state.outstandingInvoicesTotal
export const getTotalSales = (state) => state.salesTotal
export const getTotalReceipts = (state) => state.totalReceipts
export const getTotalExpenses = (state) => state.totalExpenses
export const getNetProfit = (state) => state.netProfit
export const invoiceGroupCount = (state) => state.invoiceGroupCount
export const funderCreditLimitChart = (state) =>state.funderCreditLimitChart
export const getRateOfPrePayment = (state) =>state.RateOfPrePayment
